import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function NewsletterSignup({ variant = "footer" }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email: email.trim() });
      setDone(true);
      if (data.code_issued) {
        toast.success("You're in! Check your inbox for a 15% off welcome code 💖");
      } else if (data.already_subscribed) {
        toast.info("You're already on the list — thanks babe!");
      } else {
        toast.success("Thanks for joining the list ✨");
      }
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't subscribe — try again.");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div data-testid="newsletter-success" className={variant === "footer" ? "" : "p-4"}>
        <div className="font-script text-2xl text-[#2eb6a8]">You're In, Babe ✨</div>
        <p className="text-sm text-[#4a4239] mt-1">Watch your inbox for your <strong className="text-[#e8478e]">15% off</strong> welcome code.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className={variant === "footer" ? "space-y-3" : "space-y-3"}>
      <div className="flex items-center gap-1.5 text-[#1f8d83] text-xs font-bold uppercase tracking-[0.2em]">
        <Sparkles size={13}/> Get 15% off your first order
      </div>
      <p className="text-sm text-[#4a4239] leading-relaxed">
        Join the babes — early drops, sass, and a sweet welcome code.
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="email"
          required
          data-testid="newsletter-email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          className="flex-1 bg-white border border-[#e5dccd] focus:border-[#2eb6a8] focus:ring-2 focus:ring-[#2eb6a8]/20 rounded-full px-5 py-3 text-sm outline-none text-[#1c1815]"
        />
        <button
          type="submit"
          disabled={submitting}
          data-testid="newsletter-submit"
          className="bg-[#e8478e] hover:bg-[#c93875] hover:shadow-lg hover:-translate-y-0.5 text-white text-[10px] uppercase tracking-[0.25em] font-bold px-6 py-3 rounded-full transition-all disabled:opacity-60"
        >
          {submitting ? "Sending…" : "Get My Code"}
        </button>
      </div>
    </form>
  );
}
